import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';
import { DocumentKind } from '../interfaces';

const {
  useCreate: useCreateStudentApplicationDocument,
  useGet: useStudentApplicationDocument,
  useDelete: useDeleteStudentApplicationDocument,
} = getCRUDHooks({
  entityName: 'studentApplicationDocument',
  create: (
    values: {
      documentFile: string | ArrayBuffer | null;
      documentTopic: string;
      documentKind: DocumentKind;
    },
    { studentApplicationId }: { studentApplicationId: string }
  ) =>
    clientApi
      .getOCClient()
      .helpers.studentApplication.studentApplication.id(studentApplicationId)
      .documents.create(values),

  get: ({ url, studentApplicationId }: { url: string; studentApplicationId: string }) =>
    clientApi
      .getOCClient()
      .helpers.studentApplication.studentApplication.id(studentApplicationId)
      .documents.get(url),

  remove: ({ url, studentApplicationId }: { url: string; studentApplicationId: string }) =>
    clientApi
      .getOCClient()
      .helpers.studentApplication.studentApplication.id(studentApplicationId)
      .documents.delete(url),
});

export {
  useCreateStudentApplicationDocument,
  useStudentApplicationDocument,
  useDeleteStudentApplicationDocument,
};
